import React, { CSSProperties, ReactNode } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import styles from './DeleteCustomContentsDialog.module.css';
import { useDeleteCustomContentsMutation } from '../../../generated/graphql';

type DeleteCustomContentsDialogProps = {
    onClose: () => void,
    libraryId: string,
    ids: string[];
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const DeleteCustomContentsDialog = (props: DeleteCustomContentsDialogProps) => {
    const { style, visible, libraryId, ids, onClose } = props;
    const [deleteCustomContents, deleteCustomContentsResult] = useDeleteCustomContentsMutation();
    const handleOnOkClick = () => {
        deleteCustomContents({
            variables: {
                id: libraryId,
                ids: ids
            }
        })
            .then(() => onClose())
            .catch(err => onClose());
    };

    return (
        <DialogBase
            title="Delete Custom Contents"
            type="OkCancel"
            isLoading={deleteCustomContentsResult.loading}
            visible={visible}
            onClose={onClose}
            onOkClick={handleOnOkClick}
            className={styles.DeleteCustomContentsDialog}
            style={style}
            data-testid="DeleteCustomContentsDialog">
            <p style={{ color: "var(--text-secondary)" }}>Are you sure you want to delete these custom contents?</p>
        </DialogBase>
    );
};

export default DeleteCustomContentsDialog;